import axios from 'axios'
import { API_URL } from '../../../../constants'
import { IGeneralErrorObject } from '../../../../types'

/**
 * Removes a routing configuration: the coverage card AND the payment_adapter_priority
 * rows behind it. A card is a group of priority rows, so deleting the meta row alone
 * would leave the card on screen.
 *
 * Backend: DELETE /api/internal/payment-adapter/priority/config — idempotent, a repeat
 * or a never-configured context answers 200.
 */
export interface IDeletePriorityConfigReq {
  merchantToken: string
  paymentMethodType: string
  currency: string
  direction: string
  externalUserFlag: string
  source: string
}

export interface IDeletePriorityConfigRes {
  success: boolean
  errors?: Partial<IGeneralErrorObject>
}

export const deletePriorityConfig = (params: IDeletePriorityConfigReq) =>
  axios.delete<IDeletePriorityConfigRes>(
    `${API_URL}/api/internal/payment-adapter/priority/config`,
    { params }
  )
